export default __webpack_public_path__ + "static/media/Archpriest's Visage of the Limitless Cipher.71b5e2b6.jpg";